module.exports = ":host {\n  display: block; }\n\nfooter {\n  margin: 0;\n  padding: 16px 24px;\n  color: var(--ink-3);\n  background: var(--canvas);\n  font-size: var(--fs-12); }\n\nfooter {\n  position: static;\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/footer/footer.component.scss
// module id = ./src/app/shared/footer/footer.component.scss
// module chunks = main